import * as React from 'react';
import {LoadingViewProps} from '../../../types/mx/creditoReal/components';

const LoadingView: React.FC<LoadingViewProps> = ({description, className = ''}) => (
    <div className={`text-center ${className}`}>
        <small><kbd>{description}</kbd></small>
    </div>
);

export default LoadingView;
